import AccountService from "../services/AccountService";
import PostService from "../services/PostService";
import UserService from "../services/UserService";
import NotificationService from "../services/NotificationService";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";

export default {
  login({ commit }, { username, password }) {
    console.log(username);

    return new Promise((resolve, reject) => {
      AccountService.login(username, password)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        });
    });
  },

  confirmLogin({ commit }, body) {
    return new Promise((resolve, reject) => {
      AccountService.confirmLogin(body)
        .then((res) => {
          commit("updateUserInfo", res.data);
          commit("updateUserId", res.data.Id);
          commit("updateUserToken", {
            access: res.data.Token,
            refresh: res.data.Token,
          });
          return resolve(res);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        });
    });
  },

  loginWithoutSms({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      AccountService.loginWithoutSms(username, password)
        .then((res) => {
          commit("updateUserInfo", res.data);
          commit("updateUserId", res.data.Id);
          commit("updateUserToken", {
            access: res.data.Token,
            refresh: res.data.Token,
          });
          return resolve(res);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        });
    });
  },

  resetPassword({ commit }, body) {
    return new Promise((resolve, reject) => {
      AccountService.resetPassword(body)
        .then((res) => {
          // commit('updateUserInfo', res.data)
          // commit('updateUserId', res.data.Id)
          // commit('updateUserToken', { access: res.data.Token, refresh: res.data.Token })
          return resolve(res);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        });
    });
  },

  confirmNewPassword({ commit }, body) {
    return new Promise((resolve, reject) => {
      AccountService.confirmNewPassword(body)
        .then((res) => {
          // commit('updateUserInfo', res.data)
          // commit('updateUserId', res.data.Id)
          // commit('updateUserToken', { access: res.data.Token, refresh: res.data.Token })
          return resolve(res);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        });
    });
  },

  logout({ commit }) {
    AccountService.logoutUser()
    .then((res) => {
    })
    .catch((err) => {
      console.log(err);
    }).then(() => {
      commit("authLogout", {});
    })
  },

  getTagList({ commit }) {
    return new Promise((resolve, reject) => {
      commit("updateTagListLoading", true);
      PostService.getTagList()
        .then((res) => {
          console.log("taglist:", res.data.Result);
          commit("updateTagList", res.data.Result);
          return resolve(res);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        })
        .then(() => {
          commit("updateTagListLoading", false);
        });
    });
  },

  getPosts({ commit, state }, body = {}) {
    return new Promise((resolve, reject) => {
      let oldData = body.oldData ? body.oldData : [];
      let key = body.key ? body.key : "kurumsal_haberler";
      let page = body.page ? body.page : 1;
      let perPage = body.perPage ? body.perPage : 15;
      let searchText = body.searchText ? body.searchText : "";
      let type = body.type ? body.type : "individual";
      let groupIds = body.groupIds
        ? body.groupIds
        : state.filterGroupId
        ? state.filterGroupId
        : "";
      console.log("body :", body);
      UserService.getPosts(key, page, perPage, searchText, groupIds, type)
        .then((res) => {
          const posts = res.data;
          let _data = [];
          // if ((searchText === "" || page !== 1) && !this.refreshing) {
          if (searchText === "" || page !== 1) {
            _data = [...oldData, ...posts];
          } else {
            _data = posts;
          }
          // if (this.activeTab === 1) {
          //   this.corporateData = _data;
          //   this.pageCorporate = page + 1;
          //   this.posts = posts;
          // } else {
          //   this.individualData = _data;
          //   this.pageIndividual = page + 1;
          //   this.posts = posts;
          // }
          commit("updateFeedItems", _data);
          return resolve(posts);
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
          return reject(err);
        })
        .then(() => {
          // this.loading = false;
          // this.refreshing = false;
        });
    });
  },

  setFilterGroupId({ commit }, body) {
    commit("setFilterGroupId", body ? body : null);
  },

  setUpdateDialogItem({ commit }, body) {
    commit("setUpdateDialogItem", body);
  },

  setSended({ commit }, body) {
    commit("setSendedUser", body ? body : null);
  },

  getNotifications({ commit, state }, body = {}) {
    return new Promise((resolve, reject) => {
      let oldData = body.oldData ? body.oldData : [];
      let notificationType = body.notificationType
        ? body.notificationType
        : "";
      let page = body.page ? body.page : 1;
      let perPage = body.perPage ? body.perPage : 20;
      let target = state.user.Id;
      NotificationService.getNotification(
        page,
        perPage,
        target,
        notificationType
      )
        .then((res) => {
          const notifications = res.data.Result;
          let _data = [];
          if (page !== 1) {
            _data = [...oldData, ...notifications];
          } else {
            _data = notifications;
          }
          commit("updateNotificationsData", _data);
          commit("updateTotalUnSeenNotification", res.data.TotalUnSeenItems);
          return resolve(notifications);
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
          return reject(err);
        })
        .then(() => {});
    });
  },

  readNotifications({ commit, state }, id = "") {
    return new Promise((resolve, reject) => {
      NotificationService.readNotification(id)
        .then((res) => {
          commit("readNotifications", id);
          return resolve(res);
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
          return reject(err);
        })
        .then(() => {});
    });
  },

  readAllNotifications({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("readAllNotification");
    });
  },

  remoteConfig({ commit }) {
    console.log('action remote')
    AccountService.getRemoteConfig()
    .then((res) => {
      console.log('RES', res)
      commit("setRemoteConfig", res.data);
    })
    .catch((err) => {
      console.log(err);
    }).then(() => {
      
    })
  },

  async authSocketConnection({ commit, state, dispatch }, token) {
    state.connection = new HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_CHAT_BASE_URL)
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    await state.connection.start();
    await state.connection
      .invoke("Authorize", { token })
      .then(() => {
        state.connectionStatus = true;
        state.connection.invoke("Chatbox", { token });
        state.connection.invoke("GetNotReadMessages", { token });
      })
      .catch(async (err) => {
        console.log("Socket auth error ! ", err);
        await state.connection.stop();
        dispatch('authSocketConnection', token)
      });

    // Handle connection closing
    state.connection.onclose(async () => {
      console.log("disconnected to SOCKET ", state.connection.state);
    });
    state.connection.onreconnecting((error) => {
      state.connectionStatus = false;
      console.log("reconnecitng ", state.connection.state);
    });
    state.connection.onreconnected(async (res) => {
      if (!state.connectionStatus) {
        console.log("Reconnected  >>", res);

        console.log("Reconnected state >>", state.connection.state);
        await state.connection.stop();
        dispatch('authSocketConnection', token)
      }
    });

    state.connection.onclose(async (error) => {
      console.log("onclose ", state.connection.state);
    });

    state.connection.on("ReceiveMessage", (user, message) => {
      if(message){
        let arr = state.chats
        arr.push(message)
        state.chats = arr
      }
    });

    state.connection.on("UpdateStore", (res, data) => {

    });
    state.connection.on("UsersInRoom", (user) => {

    });

    //Get messages
    state.connection.on("GetMessagesOnChat", (res) => {
      state.chats = [];
      if(res){
        let arr = res
        state.chats = arr
      }
    });
    state.connection.on("OnlineUsers", (res) => {
      console.log("Online users  > ", res);
      let arr = state.chatGroups
      arr.forEach(element => {
        res.forEach((elementOnline) => {
          if(elementOnline.userId == element.user.id){
            element.isOnline = true
          }
        });
      });
      state.chatGroups = arr
    });

    //Daha önceden mesajlanmış kullanıcılar çekiliyor.
    state.connection.on("ChatBox", (id, res) => {
      if (res && id === state.userId) {
        let arr = []
        res.forEach((element) => {
          let currentUser = element.users.filter(x => x.id != state.userId)
          if(currentUser.length > 0)
          element.user = currentUser[0]
          arr.push(element);
        });
        state.chatGroups = arr
      }
    });
    state.connection.on("GetNotReadMessages", (id, res) => {
      if (res >= 0 && id === state.userId) {
        state.unreadMessageCount = res;
      }
    });
  },

  async getChatGroups({ commit, state }, token) {
    //state.chatGroups = [];
    if (state.connection.state === "Connected") {
      await state.connection.invoke("Chatbox", { token });
    } else {
      console.log("Connection is not ready >>", state.connection.state);
      return;
    }
  },

  async joinRoom({ commit, state }, room) {
    const token = state.token;
    if (state.connection.state === "Connected") {
      await state.connection.invoke("JoinRoom", { room, token });
      state.connection.invoke("GetNotReadMessages", { token });
      return 1
    } else {
      console.log("Connection is not ready >>", state.connection.state);
      return;
    }
  },

  async outRoom({ commit, state }, room) {
    const token = state.token;
    if (state.connection.state === "Connected") {
      await state.connection.invoke("OutRoom", { room, token });
      return 1
    } else {
      console.log("Connection is not ready >>", state.connection.state);
      return;
    }
  },

  async sendMessage({ commit, state }, message) {
    if (state.connection.state === "Connected") {
      await state.connection.invoke("SendMessage", { message });
    } else {
      console.log("Connection is not ready >>", state.connection.state);
      return;
    }
  },
};
